// extracted by mini-css-extract-plugin
export default {"searchBox":"UserSearchBox_searchBox__VUaTs","inputBox":"UserSearchBox_inputBox__PhC+3"};